export const Main = ({ children }) => {
  return (
    <main>
      {children}
    </main>
  );
};
